import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'

import LevelPicker from './components/LevelPicker'

import { LOCALE_PREFIX } from './constants'
import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class BlockTitle extends PureComponent {
    static propTypes = {
        blockAccessRightsPathFn: PropTypes.func.isRequired,
        blockKey: PropTypes.string.isRequired,
        disable: PropTypes.bool.isRequired,
        disableClose: PropTypes.bool.isRequired,
        id: PropTypes.string.isRequired,
        loading: PropTypes.bool.isRequired,
        module: PropTypes.string.isRequired,
        onClickHandler: PropTypes.func,
        open: PropTypes.bool.isRequired,
    }

    static defaultProps = {
        onClickHandler: () => {},
    }

    onClickHandler = (_e) => {
        const { onClickHandler } = this.props

        _e.preventDefault()
        _e.stopPropagation()

        onClickHandler()
    }

    render() {
        const { disable, disableClose, id, loading, module, blockKey, open, blockAccessRightsPathFn } = this.props

        const titleTextId = `${LOCALE_PREFIX}.${module}.${blockKey}`

        const levelPicker =
            !disable && !loading ? (
                <div className={'block-title-level-picker'}>
                    <LevelPicker
                        module={module}
                        id={id}
                        blockKey={blockKey}
                        blockAccessRightsPathFn={blockAccessRightsPathFn}
                    />
                </div>
            ) : null

        const noDataMsg =
            disable && !loading ? (
                <div className={'block-title-no-data-msg'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.noDataMsg`} />
                </div>
            ) : null

        const isCollapse = !open && !disable && !loading
        const isDisable = disable && !loading

        return (
            <div className={'block-title'}>
                <div className={'block-title-content'}>
                    <div
                        className={cx(
                            'block-title-text',
                            isCollapse && 'collapse',
                            isDisable && 'disable',
                            loading && 'loading',
                            disableClose && 'disableClose'
                        )}
                        onClick={this.onClickHandler}
                    >
                        <span className={'text-wrapper'}>
                            <FormattedMessage id={titleTextId} />
                        </span>
                        {noDataMsg}
                    </div>
                    {levelPicker}
                </div>
            </div>
        )
    }
}
